import theme from '../../../theme';
import { defaults } from 'chart.js';
export * from './Doughnut';
export * from './Bar';
export * from './Legend';
export * from './Line';

defaults.global.defaultFontFamily = theme.typography.fontFamily;
